export default "__VITE_ASSET__Bpy_$vzp__"